import dynamic from 'next/dynamic';
import LayoutLaunch from '~/layouts/LayoutLaunch';
import SEOTags from '~/components/SEOTags';

const SneakerIntroduction = dynamic(() => import('~/sections/SneakerIntroduction'), { ssr: false });
const SneakerUpcoming = dynamic(() => import('~/sections/SneakerUpcoming'), { ssr: false });
const SneakerProductList = dynamic(() => import('~/sections/SneakerProductList'), { ssr: false });

const SneakerRelease = () => {
    return (
        <LayoutLaunch>
            <SEOTags
                metaTitle="Sneaker Release Dates & Launch Calendar 2024 | US Drops"
                description="Stay updated on the latest 2024 sneaker release dates & launch calendar. Find upcoming drops from Nike, Air Jordan, Adidas, Vans, Converse, Reebok, Dunk & more."
            />
            <SneakerIntroduction />
            <SneakerUpcoming />
            <SneakerProductList />
        </LayoutLaunch>
    );
};

export default SneakerRelease;
